// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-intranet-layout__navbar-item',
    // #endregion
    // #region Props
    props: {
        menuItem: {
            type: Object,
            required: true,
            default: null
        },
        align: {
            type: String,
            required: false,
            default: 'left'
        }
    },
    // #endregion
    // #region Computed
    computed: {
        currentUser() {
            return this.$appHost.store.get("session").currentUser;
        },
        userDisplayName() {
            return this.currentUser?.firstName ?? this.currentUser?.displayName;
        },
    },
    // #endregion
    // #region Methods
    methods: {
        getMenuItemCaption(menuItem) {
            if (menuItem.caption === '$UserName') {
                return this.$t('client.Common.Hello') + " " + this.userDisplayName;
            }
            else {
                return menuItem.caption;
            }
        }
    },
    // #endregion
});
// #endregion
